import { NavigationGuard } from "vue-router";
import userStore from "@/store/userStore";

const ensureUserAuthorized: NavigationGuard = async (to, _, next) => {
  if (to.meta.allowedRoles) {
    const allowedRoles: string[] = to.meta.allowedRoles;
    if (!allowedRoles.some(r => userStore.hasRole(r))) {
      if (!(to.name == "Video Requests") || !userStore.canAccessVideoRequests()) {
        next({ name: "Home" });
        return;
      }
    }
  }

  next();
};

export default ensureUserAuthorized;
